import { Component } from '@angular/core';
import { PeticionesService } from './servicios/httpservice';
import { Router, Event, NavigationEnd } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs/operators';
declare const bootstrap: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'] 
})
export class AppComponent {
  title = 'modVentas';
  public mostrarMenu:boolean=true;
  constructor(private menuService: PeticionesService,private router: Router, private viewportScroller: ViewportScroller) {
     // Suscribir al array del carrito
     this.menuService.menu$.subscribe((nuevoValor) => {
      this.mostrarMenu = nuevoValor;
     /*  console.log(this.mostrarMenu) */
    });
  }

  ngOnInit(): void { 
    this.router.events
    .pipe(filter((event: Event) => event instanceof NavigationEnd))
    .subscribe(() => {
      const matSidenavContent = document.querySelector('mat-sidenav-content');
      if (matSidenavContent) {
        matSidenavContent.scrollTo(0, 0);
      }
    });
  }

}
